import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import RailForm from "./RailForm";

interface CreateRailModalDialogButtonProps {
  onCreated?: (id: string) => void;
}

const CreateRailModalDialogButton: FC<CreateRailModalDialogButtonProps> = ({ onCreated }) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.rails.createNew}>
          <RailForm onClose={() => setShowNewItemDialog(false)} onCreated={onCreated} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateRailModalDialogButton;
